<!-- ProductAnalysis.vue -->
<script setup lang="ts">
import { BarChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
import { computed } from "vue";

// Register Chart.js components
Chart.register(...registerables);

// Chart data
const chartData = computed(() => ({
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
  datasets: [
    {
      label: "Product HX",
      backgroundColor: "#eb9fc1",
      borderColor: "#e55b83",
      borderWidth: 1,
      data: [10, -2, 22, 9, -28, 15],
      // Note: showLine and hideInLegendAndTooltip are not standard properties
      // categoryPercentage and barPercentage are handled in options
    },
    {
      label: "Product BM",
      backgroundColor: "#fde4a9",
      borderColor: "#facd55",
      borderWidth: 1,
      data: [20, -2, 30, 19, -21, -5],
    },
    {
      label: "Product WR",
      backgroundColor: "#9bdddf",
      borderColor: "#62c1c0",
      borderWidth: 1,
      data: [-6, -21, 21, -9, 2, 10],
    },
    {
      label: "Product PK",
      backgroundColor: "#90cdf4",
      borderColor: "#3ba2eb",
      borderWidth: 1,
      data: [16, 10, 12, -20, 18, 2],
    },
  ],
}));

// Chart options for Chart.js v3 - Horizontal Bar
const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  indexAxis: "y" as const, // Makes it horizontal bar chart
  plugins: {
    title: {
      display: true,
      text: "Product Analysis",
      position: "bottom" as const,
      font: {
        size: 20,
        weight: "bold" as const,
      },
    },
    legend: {
      position: "top" as const,
      labels: {
        font: {
          size: 16,
          weight: "bold" as const,
        },
        boxWidth: 20,
        padding: 20,
      },
    },
    tooltip: {
      mode: "index" as const,
      intersect: false,
    },
  },
  scales: {
    x: {
      display: true,
      offset: true,
      grid: {
        display: true,
        drawBorder: true,
      },
      ticks: {
        callback: function (value: number) {
          return value; // Format ticks if needed
        },
      },
      title: {
        display: true,
        text: "Value",
      },
    },
    y: {
      display: true,
      grid: {
        display: true,
        drawBorder: true,
      },
      title: {
        display: true,
        text: "Month",
      },
    },
  },
  elements: {
    bar: {
      borderWidth: 1,
      // For horizontal bars, these properties work differently
      borderSkipped: false as const,
    },
  },
  // Bar percentage settings in Chart.js v3
  datasets: {
    bar: {
      categoryPercentage: 0.95,
      barPercentage: 0.95,
      // Group bars together
      grouped: true,
    },
  },
}));

// If you need to update chart data dynamically
const updateChartData = (newData: number[][]) => {
  // This would require a reactive approach
  // You could use a ref for chartData and update it
  console.log("Update chart with new data:", newData);
};

// Expose methods if needed
defineExpose({
  updateChartData,
});
</script>

<template>
  <BarChart :chart-data="chartData" :options="chartOptions" />
</template>
